export default "__VITE_ASSET__uzItZlWV__"